import type { BoxShadowType } from '@vedalib/editor/lib/brand'

export const safeParseBoxShadow = (value?: string | null): BoxShadowType => {
  try {
    return value ? JSON.parse(value) : { preset: 'none', size: 0, color: '#0000001A' }
  } catch (error) {
    return { preset: 'none', size: 0, color: '#0000001A' }
  }
}
